<template>
  <div class="ad-series-wrap">
    <div class="card-header">广告系列</div>
    <div v-loading="loading">
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="primary" @click="addAdGroup">新建广告系列</el-button>
        <el-button icon="el-icon-plus" class="def-btn" @click="hasAdGroup">已有广告系列</el-button>
      </div>
      <div class="newgroup-wrap" style="padding-top: 20px" v-if="newAdType">
        <ul class="modal-form">
          <el-form :model="formData" :rules="rules" ref="ruleForm">
            <li class="form-item">
              <span class="form-label require">广告系列名称：</span>
              <div class="form-value">
                <select-input
                  ref="selectInputRef"
                  placeholder="(必填)广告系列名称"
                  :dataList="showAdList"
                  v-model="formData.campaignNameRule"
                ></select-input>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">广告系列子类型：</span>
              <div class="form-value">
                <el-radio-group
                  v-model="formData.advertisingChannelSubType"
                  @change="changeBidType"
                >
                  <el-radio label="APP_CAMPAIGN">应用安装</el-radio>
                </el-radio-group>
              </div>
            </li>
            <li class="form-item">
              <span class="form-label" style="padding-top: 0px">投放时间：</span>
              <div class="form-value">
                <el-radio-group v-model="formData.schedule_type" style="display: block">
                  <el-radio label="SCHEDULE_FROM_NOW">从今天到长期投放</el-radio>
                  <el-radio label="SCHEDULE_START_END">设置开始和结束日期</el-radio>
                </el-radio-group>
                <el-form-item prop="time">
                  <el-date-picker
                    v-if="formData.schedule_type === 'SCHEDULE_START_END'"
                    v-model="formData.time"
                    type="daterange"
                    align="right"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :clearable="false"
                    :picker-options="pickerOptions"
                    style="width: 320px; margin-top: 8px"
                  ></el-date-picker>
                </el-form-item>
              </div>
            </li>
          </el-form>
        </ul>
      </div>
      <div class="table-wrap" v-else>
        <el-table :data="adGroupTable" style="width: 100%" v-loading="tableLoading">
          <el-table-column prop="name" label="广告系列名称"> </el-table-column>
          <el-table-column prop="advertiserName" label="广告账户"> </el-table-column>
          <el-table-column prop="time" label="投放时间"> </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 已有广告系列弹框 -->
    <el-dialog
      title="已有广告系列"
      :visible.sync="showHasModal"
      width="800px"
      @opened="openHasModal"
    >
      <div class="modal-body">
        <el-input
          v-model="searchName"
          style="width: 300px; margin: 0px 12px 12px 0"
          placeholder="请输入广告系列"
        >
        </el-input>
        <el-button type="primary" @click="searchProject">查询</el-button>
        <el-button type="primary" :loading="refreshLoading" @click="refreshCampign">同步</el-button>
        <div class="transfer-wrap">
          <el-table
            :data="projectList"
            v-loading="modalLoading"
            style="width: 100%"
            max-height="500px"
          >
            <el-table-column prop="campaignId" label="广告系列ID"> </el-table-column>
            <el-table-column prop="campaignName" label="广告系列名称"> </el-table-column>
            <el-table-column prop="packageName" label="应用包名"> </el-table-column>
            <el-table-column prop="operate" label="操作" width="130px">
              <template slot-scope="scope">
                <el-button type="text" @click="confirmeSelect(scope.row)">使用该广告系列</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap">
          <self-pagination
            :total="projectPageData.total"
            :pageSize="projectPageData.size"
            :currentPage="projectPageData.page"
            ref="tabelPagination"
            @getCurrentPage="changeProjectPage"
            @handleSizeChange="changePageSize"
          ></self-pagination>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getAdCampaignList,
  refreshGoogleCampaginList,
  getAdCampaignDetail,
} from "@/api/promotion-google.js";
import nameTransforUtil from "./config/nameTransforUtil.js";
import SelectInput from "./components/selectInput.vue";
export default {
  components: {
    SelectInput,
  },
  data() {
    return {
      newAdType: true, //是否展示新建表单
      showHasModal: false,
      modalLoading: false,
      loading: false,
      selectItem: [],
      projectNameList: [
        "创意组名称",
        "推广目标",
        "应用名称",
        "地区",
        "语言",
        "创建时间",
        "优化目标",
        "出价",
        "地区组名",
        "应用系统",
        "开始日期",
        "时分秒",
        "首个图片名称",
        "首个视频名称",
      ],
      showMore: true,
      formData: {
        campaignNameRule: "",
        advertisingChannelSubType: "APP_CAMPAIGN",
        schedule_type: "SCHEDULE_FROM_NOW",
        time: [],
      },
      projectPageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      refreshLoading: false,
      searchName: "",
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 3600 * 24 * 1000;
        },
      },
      rules: {
        campaignNameRule: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value === "" && this.newAdType === true) {
                callback(new Error("广告系列名称必填"));
              } else {
                callback();
              }
            },
          },
        ],
        time: [
          {
            trigger: ["blur", "change"],
            validator: (rule, value, callback) => {
              if (value?.length < 2 && this.formData.schedule_type === "SCHEDULE_START_END") {
                callback(new Error("投放时间必填"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      //已有弹框相关内容****************************************************
      curId: null,
      projectList: [],
      adGroupTable: [],
      tableLoading: false,
    };
  },
  mounted() {
    this.saveInStore();
  },
  methods: {
    addAdGroup() {
      if (!this.newAdType) {
        this.newAdType = true;
        this.$store.commit("set_ad_series_google", {
          campaignId: "",
        });
      }
    },
    //选择已有相关*********************************************************
    hasAdGroup() {
      if (!this.adCount) {
        this.$alert("请选择广告账号后再操作", "提示", {
          confirmButtonText: "确定",
        });
      } else {
        this.showHasModal = true;
      }
    },
    openHasModal() {
      this.curId = this.adCount;
      this.projectPageData.page = 1;
      this.searchName = "";
      this.getProjectList();
    },
    getProjectList() {
      this.modalLoading = true;
      getAdCampaignList({
        advertiserId: this.adCount,
        pageNum: this.projectPageData.page,
        pageSize: this.projectPageData.size,
        platType: 5,
        search: this.searchName,
      }).then((res) => {
        this.modalLoading = false;
        if (res.code === "0000") {
          this.projectList = res.data.list;
          this.projectPageData.total = res.data.total;
        }
      });
    },
    refreshCampign() {
      this.refreshLoading = true;
      refreshGoogleCampaginList({ advertiserId: this.adCount }).then((res) => {
        this.refreshLoading = false;
        if (res.code === "0000") {
          this.$message.success("同步成功");
          this.getProjectList();
        }
      });
    },
    searchProject() {
      this.projectPageData.page = 1;
      this.getProjectList();
    },
    changeProjectPage(page) {
      this.projectPageData.page = page;
      this.getProjectList();
    },
    changePageSize(size) {
      this.projectPageData.page = 1;
      this.projectPageData.size = size;
      this.getProjectList();
    },
    //选择已有确定
    confirmeSelect(data) {
      this.$store.commit("set_ad_series_google", {
        campaignId: data.campaignId,
      });
      this.showHasModal = false;
      this.newAdType = false;
    },
    // 设置已有广告系列数据
    setAlreadyAdData(campaignId) {
      this.loading = true;
      getAdCampaignDetail({
        advertiserId: this.adCount,
        campaignId,
      }).then((res) => {
        this.$store.commit("set_ad_series_google", res.data);
        const { campaignName, advertiserId, advertiserName, startDate, endDate } = res.data;
        let endStr = endDate < "2037-12-30" ? endDate : "长期投放";
        this.adGroupTable = [
          { name: campaignName, advertiserId, advertiserName, time: `${startDate}--${endStr}` },
        ];
        this.modalLoading = false;
        this.loading = false;
        this.$emit("confirmeAdSeries");
      });
    },
    // 新建广告系列保存到store
    saveInStore() {
      if (this.newAdType) {
        //保存新建的广告系列表单数据到store
        const data = JSON.parse(JSON.stringify(this.formData));
        const { schedule_type, time, campaignNameRule } = data;
        if (schedule_type === "SCHEDULE_START_END" && time?.length > 1) {
          data.startDate = time[0];
          data.endDate = time[1];
        } else {
          data.startDate = "";
          data.endDate = "";
        }
        data.campaignNameRule = nameTransforUtil.showDataToApi(campaignNameRule);
        delete data.time;
        this.$store.commit("set_ad_series_google", data);
      }
    },
    checkData() {
      return new Promise((resolve, reject) => {
        if (this.newAdType) {
          this.$refs.selectInputRef.checkData(),
            this.$refs.ruleForm.validate((valid) => {
              if (valid) {
                this.saveInStore();
                resolve();
              } else {
                reject();
              }
            });
        } else {
          this.saveInStore();
          resolve();
        }
      });
    },
    changeBidType() {
      this.saveInStore();
    },
  },
  computed: {
    showAdList() {
      if (!this.showMore) {
        return this.projectNameList.slice(0, 6);
      }
      return this.projectNameList;
    },
    ...mapState({
      adCount: (state) => state.PromotionGoogle.draftCampaign.advertiserId,
      alreadyCampaignId: (state) => state.PromotionGoogle.draftCampaign.campaignId,
      draftCampaign: (state) => state.PromotionGoogle.draftCampaign,
    }),
    adSeriesData() {
      const { campaignNameRule, startDate, endDate } = this.draftCampaign;
      return {
        campaignNameRule,
        startDate,
        endDate,
      };
    },
  },
  watch: {
    // adCount: {
    //   handler() {
    //     this.addAdGroup();
    //   },
    //   immediate: true,
    // },
    adSeriesData: {
      handler(val) {
        const { campaignNameRule, startDate, endDate } = val;
        this.formData.campaignNameRule = nameTransforUtil.apiDatatoShow(campaignNameRule);
        if (startDate && endDate && endDate < "2037-12-30") {
          this.formData.schedule_type = "SCHEDULE_START_END";
          this.formData.time = [startDate, endDate];
        } else {
          this.formData.schedule_type = "SCHEDULE_FROM_NOW";
        }
      },
      deep: true,
    },
    alreadyCampaignId: {
      handler(val) {
        this.newAdType = val ? false : true;
        if (val) {
          this.setAlreadyAdData(val);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
.ad-series-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
  }
  .btn-group {
    margin-top: 16px;
    .def-btn {
      color: rgba(24, 144, 255, 1);
      border: 1px solid rgba(24, 144, 255, 1);
    }
  }
  .table-wrap {
    margin-top: 16px;
    .show-wrap {
      font-size: 14px;
      .show-label {
        color: rgba(0, 0, 0, 0.65);
      }
      .icon {
        cursor: pointer;
        margin-left: 8px;
      }
    }
  }
  .newgroup-wrap,
  .modal-body {
    .modal-form {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 16px;
        /deep/.el-form-item__error {
          top: 11px;
          left: 330px;
        }
        /deep/ .el-form-item {
          margin-bottom: 6px;
        }
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 130px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-top: 6px;
          &.require::before {
            content: "*";
            display: inline-block;
            color: red;
            margin-right: 4px;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          .list-wrap {
            max-height: 120px;
            overflow: auto;
            .adCountItem {
              height: 22px;
              line-height: 22px;
              border-radius: 2px;
              display: inline-block;
              padding: 0 8px;
              margin: 0 8px 8px 0;
              background: rgba(233, 233, 233, 0.6);
              color: rgba(0, 0, 0, 0.65);
              .close-btn {
                display: inline-block;
                margin-left: 6px;
                font-size: 18px;
                cursor: pointer;
                position: relative;
                top: 1px;
              }
            }
          }
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
        }
      }
    }
    .footer-wrap {
      text-align: right;
      display: block;
      padding-bottom: 24px;
    }
    .transfer-wrap {
      display: flex;
      margin-bottom: 24px;
      .top-list {
        width: 250px;
        border: 1px solid #ebeef5;
        .list-header {
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          padding: 10px 0px 10px 12px;
          border-bottom: 1px solid #ebeef5;
        }
        .count-list {
          overflow: auto;
          height: 316px;
          padding: 0px;
          margin: 0px;
          list-style: none;
          .count-item {
            cursor: pointer;
            padding: 6px 10px;
            position: relative;
            .item-detial {
              display: block;
              font-size: 12px;
              color: #666;
            }
            &.cur {
              background-color: rgba(230, 247, 255, 1);
            }
          }
          .item-count {
            position: absolute;
            right: 10px;
            top: 11px;
            width: 17px;
            height: 17px;
            border-radius: 3px;
            background: rgba(24, 144, 255, 1);
            color: rgba(255, 255, 255, 1);
            font-size: 14px;
            text-align: center;
            line-height: 17px;
          }
        }
      }
      /deep/ .el-checkbox {
        margin-right: 0px;
      }
    }
  }
}
</style>
